import { render, staticRenderFns } from "./confirmChangePrice.vue?vue&type=template&id=fe78ac44&scoped=true"
import script from "./confirmChangePrice.vue?vue&type=script&lang=js"
export * from "./confirmChangePrice.vue?vue&type=script&lang=js"
import style0 from "./confirmChangePrice.vue?vue&type=style&index=0&id=fe78ac44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe78ac44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CouponItem: require('/drone/src/components/CouponItem/index.vue').default})
